import "bootstrap"
import objectFitImages from 'object-fit-images';
import './vue/index'
import 'alpinejs'
import Cookies from 'js-cookie'
import _ from 'lodash'
import moment from 'moment'
import Sticky from 'sticky-js'
import Swiper from "swiper";

jQuery(function ($) {

    objectFitImages()

    const header = new Sticky('.desktop-sticky-header')

    // new Sticky('.mobile-sticky-header');
    $('[data-scroll-to-top]').on("click", function () {
        $('html, body').animate({scrollTop: 0}, 200);
    });


    /*
    |--------------------------------------------------------------------------
    | Formidable Radio Labels Active Class
    |--------------------------------------------------------------------------
    */
    function setRadioLabelToActive(radioDomNode) {
        $(radioDomNode).closest('.frm_opt_container').find('label').removeClass('active')
        $(radioDomNode).closest('label').addClass('active')
    }

    // on change update active classes
    $('.frm_radio input').change(function (e) {
        setRadioLabelToActive(e.currentTarget)
    });

    // on page load, set active classes
    (function () {
        $('.frm_radio input').each(function (index, inputElement) {
            if (inputElement.checked) {
                setRadioLabelToActive(inputElement)
            }
        })
    })()


    /**
     * Swiper Init
     */
    var swiperBlock = new Swiper('.slider-block.swiper-container', {
        autoHeight: true,
        loop: true,
        autoplay: {
            delay: 3000,
        },
        navigation: {
            nextEl: '.slider-block .swiper-button-next',
            prevEl: '.slider-block .swiper-button-prev',
        },
    });

    /**
     * Swiper Init
     */
    var swiperBlock = new Swiper('.slider-card-grid.swiper-container', {
        slidesPerView: 1,
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
        },
        spaceBetween: 30,
        autoHeight: true,
        loop: false,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.slider-card-grid .swiper-pagination',
            bulletActiveClass: 'bg-secondary tw-opacity-100',
            clickable: true,
        },
    });
});


/*
|--------------------------------------------------------------------------
| Logic for showing the donate modal
|--------------------------------------------------------------------------
*/
jQuery(function ($) {
    if (!document.body.classList.contains('single-post') || !window.hasOwnProperty('donateModalConfig')) {
        return
    }

    const postId = window.donateModalConfig.article_id
    const daysToShowAgain = window.donateModalConfig.show_popup_every_x_days
    const settings = JSON.parse(Cookies.get('donateModalSettings') || JSON.stringify({
        lastShownTime: moment().toISOString(),
        postsRead: [],
    }))
    const numberOfArticlesRead = settings.postsRead.length
    const targetDateToShowAgain = moment(settings.lastShownTime).add(daysToShowAgain, 'days')

    // add the current article they're about to read to the list
    // if it's not already in there
    if (!settings.postsRead.includes(postId)) {
        settings.postsRead.push(postId)
    }

    if (moment().isAfter(targetDateToShowAgain) || location.search.includes('testDonateModal')) {
        const $modal = $('#donate-modal')
        const newHtml = $modal.html().replace('{{articles_read}}', numberOfArticlesRead)
        $modal.html(newHtml)
        $('#donate-modal').modal('show')
        settings.lastShownTime = moment().toISOString()
    }

    Cookies.set('donateModalSettings', JSON.stringify(settings), {expires: 365})
})